const routeHome = () => '/moviesinfo/';

export default routeHome;
